import React from 'react';
import { Heading } from '../heading';
import { Text } from '../text';
import { Badge } from '../badge';

const ConvenioHeader = ({ convenio, beneficiarios = [], leftAction, actions }) => {
  const primaryBeneficiario = beneficiarios[0]?.nombre || '';
  const extraCount = Math.max(0, beneficiarios.length - 1);

  return (
    <div className="flex items-center gap-3 mb-6 flex-wrap">
      {leftAction}
      <div className="flex-1 min-w-0">
        <Heading>{convenio.nombre}</Heading>
        {convenio.descripcion && <Text className="text-sm">{convenio.descripcion}</Text>}
        {primaryBeneficiario && (
          <Text className="text-xs text-gray-500 mt-1">
            Beneficiario: <span className="font-medium text-gray-700">{primaryBeneficiario}</span>
            {extraCount > 0 && <span className="text-gray-500"> +{extraCount} más</span>}
          </Text>
        )}
      </div>
      <Badge color={convenio.estatus === 'activo' ? 'green' : 'zinc'}>
        {convenio.estatus === 'activo' ? 'Activo' : 'Inactivo'}
      </Badge>
      {actions}
    </div>
  );
};

export default ConvenioHeader;
